import { Avatar, Group, Stack, Text } from "@mantine/core";
import { IconEqual, IconTrendingDown, IconTrendingUp } from "@tabler/icons-react";

import { PerformanceBadge } from "./PerformanceBadge";

import type { MantineSize, MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type PerformanceProps = {
  description: string;
  size?: MantineSize;
  suffix?: string;
  value: number;
  withAvatar?: boolean;
} & MantineStyleProps;

export const Performance: FC<PerformanceProps> = ({
  description,
  size = "lg",
  suffix,
  value,
  withAvatar = true,
  ...props
}) => {
  const c = value > 0 ? "success.7" : value < 0 ? "danger.7" : "gray.8";
  const AvatarIcon = value > 0 ? IconTrendingUp : value < 0 ? IconTrendingDown : IconEqual;

  return (
    <Group align="center" wrap="nowrap" {...props}>
      {withAvatar && <Avatar color={c}>{<AvatarIcon size={20} />}</Avatar>}
      <Stack gap="1">
        <Text size={size}>{description}</Text>
        <PerformanceBadge suffix={suffix} value={value} />
      </Stack>
    </Group>
  );
};
